import { useAuth } from '../../login/AuthContext';
import { IconButton, Tooltip } from '@mui/material';
import { ContentCopyOutlined, RefreshOutlined, BlockOutlined, CheckCircleOutlined, QrCode2 } from '@mui/icons-material';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import { isLisansAktif } from './CustomerDetailsUtils.jsx';

const LicenseActions = ({
  lisans,
  onRenewLicense,
  onCopyLicenseInfo,
  onCertificateGenerate,
  onPasifeAl,
  onAktifeAl,
  onTokenRenew,
  isBayiFullAccess,
}) => {
  const handleRenew = () => {
    if (onRenewLicense) {
      onRenewLicense(lisans);
    }
  };

  const handleCopy = () => {
    if (onCopyLicenseInfo) {
      onCopyLicenseInfo(lisans);
    }
  };

  const handleCertificate = () => {
    if (onCertificateGenerate) {
      onCertificateGenerate(lisans);
    }
  };

  const isPasif = !isLisansAktif(lisans);

  const { hasPermission } = useAuth();

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      {hasPermission('admin') && (
      <Tooltip title="Lisansı boşta bırak (yenileme talebi için)">
        <IconButton
          size="small"
          color="primary"
          onClick={handleRenew}
        >
          <RefreshOutlined fontSize="small" />
        </IconButton>
      </Tooltip>)}
      <Tooltip title="Lisans Bilgilerini Kopyala">
        <IconButton
          size="small"
          color="secondary"
          onClick={handleCopy}
        >
          <ContentCopyOutlined fontSize="small" />
        </IconButton>
      </Tooltip>
      {hasPermission('admin') && (
      <Tooltip title="Sertifika Oluştur">
        <IconButton
          size="small"
          onClick={handleCertificate}
        >
          <TextSnippetOutlinedIcon/>
        </IconButton>
      </Tooltip>)}
      {onTokenRenew && lisans.moduleQrMenu && (
        <Tooltip title="QR Menü token yenile">
          <IconButton size="small" color="info" onClick={() => onTokenRenew(lisans.Id)}>
            <QrCode2 fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      {isBayiFullAccess && !isPasif && onPasifeAl && (
        <Tooltip title="Lisansı pasife al (kullanımı engeller; tekrar kullanım için yeni sipariş gerekir)">
          <IconButton size="small" color="warning" onClick={() => onPasifeAl?.(lisans.Id)}>
            <BlockOutlined fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      {isPasif && onAktifeAl && (lisans.AktifEdilebilir !== false) && (
        <Tooltip title="Lisansı aktife al">
          <IconButton size="small" color="success" onClick={() => onAktifeAl(lisans.Id)}>
            <CheckCircleOutlined fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </div>
  );
};

export default LicenseActions